import React, { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    useRecordContext,
    SelectInput,
    ReferenceField,
    BooleanInput,
    useGetOne
} from 'react-admin';
import {
    Box,
    Grid,
    LinearProgress
} from '@mui/material';
import { useGetCountries } from "../global-hooks/default-system-hooks";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const EditAddressTitle: () => JSX.Element = (): JSX.Element => {
    const record: any = useRecordContext();
    const { data: user, isPending, error } = useGetOne('customers', { id: record?.customer });
    if (!record) return null;
    if (isPending) {
        return (
            <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
        );
    }
    if (error) {
        return (
            <span>{ "Customer Address" }</span>
        );
    }
    return <span>{ "Customer Address - " + user.name }</span>
}

export const CustomerAddressEdit: () => JSX.Element = (): JSX.Element => {
    const { loadedCountries, loading } = useGetCountries();
    return (
        <Edit redirect={ false } title={ <EditAddressTitle /> }>
            <SimpleForm>
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems:'center' }}>
                            <span>{ "Customer:" }</span>
                            <ReferenceField source="customer" reference="customers" />
                        </Box>
                        <TextInput name="lineOne" source="lineOne" validate={[required()]} />
                        <TextInput name="lineTwo" source="lineTwo" />
                        <TextInput name="city" source="city" validate={[required()]} />
                        <TextInput name="county" source="county" />
                    </Grid>
                    <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                        <TextInput name="postcode" source="postcode" validate={[required()]} />
                        { (loading) &&
                            <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                        }
                        { (!loading) &&
                            <SelectInput
                                name="country"
                                source="country"
                                optionValue="id"
                                choices={ loadedCountries }
                                validate={[required()]}
                            />
                        }
                        <BooleanInput source="defaultAddress" name="defaultAddress" />
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}